import script from "./CopyUsersAndGroupsDialogView.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyUsersAndGroupsDialogView.vue?vue&type=script&setup=true&lang=js"

import "./CopyUsersAndGroupsDialogView.vue?vue&type=style&index=0&id=236d5b0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-236d5b0a"]])

export default __exports__